// 蓝色主题配置 - 专业、理性
export const blueTheme = {
  colors: {
    'psychology-primary': '#1e40af',      // 深蓝色 - 专业、可信
    'psychology-secondary': '#10b981',    // 薄荷绿 - 平衡、成长
    'psychology-accent': '#f59e0b',       // 温暖橙色 - 活力、关注
    'psychology-calm': '#f8fafc',         // 浅灰蓝 - 冷静、专业
    'psychology-warm': '#f1f5f9',         // 浅蓝灰 - 温和、专业
    'psychology-success': '#059669',      // 深绿色 - 成功、积极
    'psychology-info': '#3b82f6',         // 信息蓝 - 补充色
    'psychology-warning': '#d97706',      // 警告橙 - 提醒色
  },
  name: 'blue',
  description: '专业蓝色主题 - 理性、学术'
}
